import { render, staticRenderFns } from "./pagination2.vue?vue&type=template&id=ac846f66"
import script from "./pagination2.vue?vue&type=script&lang=js"
export * from "./pagination2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports